import React, { Component } from "react";
import { trans, setSpaceAfterNLetter } from "../../helpers/index";

class DetachModal extends Component {
  render() {
    return (
      <div className="modal modal--full fade show scroller-block">
        <div className="modal__content modal-dialog pr">
          <div className="table">
            <div className="table-cell">
              <div className="modal__inner pr">
                <h3 className="modal__title monserrat-medium fs32 tc">
                  {trans(this.props.trans, "detach_modal.title")}
                </h3>

                <p className="modal__description fs13 tc">
                  {trans(this.props.trans, "detach_modal.text_fragment1")}{" "}
                  <b>+374 {setSpaceAfterNLetter(this.props.number1, 2)}</b>{" "}
                  {trans(this.props.trans, "detach_modal.text_fragment2")}{" "}
                  <b>+374 {setSpaceAfterNLetter(this.props.number2, 2)}</b>{" "}
                  {trans(this.props.trans, "detach_modal.text_fragment3")}
                </p>

                <button
                  className={`modal__submit-btn btn btn--with-space btn--yellow${
                    this.props.buttonLoading ? " btn--loading" : ""
                  }`}
                  type="submit"
                  onClick={() => this.props.confirmAction()}
                  disabled={this.props.buttonLoading}
                >
                  {trans(this.props.trans, "detach_modal.confirm")}
                </button>

                <button
                  className="modal__cancel-btn btn btn--white"
                  type="button"
                  onClick={() => this.props.cancelAction()}
                  disabled={this.props.buttonLoading}
                >
                  {trans(this.props.trans, "detach_modal.reject")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DetachModal;
